"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var atai_1 = require("./atai");
function wareki(date, type, unit) {
    if (type === void 0) { type = 'full'; }
    if (unit === void 0) { unit = '年'; }
    var _a = atai_1.default(date).wareki, gengo = _a.gengo, tanGengo = _a.tanGengo, alphaGengo = _a.alphaGengo, nen = _a.nen;
    var jaYear = nen === 1 ? '元' : nen;
    switch (type) {
        case 'short':
            return "" + tanGengo + jaYear + unit;
        case 'alpha':
            return "" + alphaGengo + jaYear + unit;
        default:
            return "" + gengo + jaYear + unit;
    }
}
exports.default = wareki;
